export const SET_PAGE_VIEWER_SOURCE = 'setPageViewerSource';
export const SET_PAGE_VIEWER_VISIBLE = 'setPageViewerVisible';
